import { useAuth } from './AuthContext';
import { FaGoogle, FaUsers, FaLock, FaKey } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { login, adminLogin, error, user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [adminUsername, setAdminUsername] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [adminError, setAdminError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Redirect to home if already authenticated
  useEffect(() => {
    if (isAuthenticated && user) {
      navigate('/');
    }
  }, [isAuthenticated, user, navigate]);

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setAdminError('');
    setIsSubmitting(true);

    const result = await adminLogin(adminUsername, adminPassword);

    if (!result.success) {
      setAdminError(result.error || 'Invalid credentials');
    } else {
      // Successfully logged in, redirect will happen via useEffect
      console.log('Admin login successful, redirecting...');
    }
    
    setIsSubmitting(false);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          width: '100%',
          background: 'white',
          borderRadius: '16px',
          padding: '48px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
        }}
      >
        {/* Logo Section */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '80px',
            height: '80px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '50%',
            margin: '0 auto 24px',
          }}
        >
          <FaUsers style={{ fontSize: '40px', color: 'white' }} />
        </div>

        <h1
          style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#2d3748',
            marginBottom: '12px',
          }}
        >
          Staff Council
        </h1>

        <h2
          style={{
            fontSize: '20px',
            fontWeight: '500',
            color: '#4a5568',
            marginBottom: '8px',
          }}
        >
          NYU Abu Dhabi
        </h2>

        <p
          style={{
            fontSize: '15px',
            color: '#718096',
            marginBottom: '32px',
            lineHeight: '1.6',
          }}
        >
          Sign in with your NYU Google account to access the Staff Council platform
        </p>

        {/* Error Message */}
        {(error || adminError) && (
          <div
            style={{
              padding: '16px',
              background: '#fee',
              border: '1px solid #fc8181',
              borderRadius: '8px',
              marginBottom: '24px',
              display: 'flex',
              alignItems: 'start',
              gap: '12px',
            }}
          >
            <FaLock style={{ color: '#c53030', marginTop: '2px', flexShrink: 0 }} />
            <div style={{ textAlign: 'left' }}>
              <div
                style={{
                  fontWeight: '600',
                  color: '#c53030',
                  marginBottom: '4px',
                  fontSize: '14px',
                }}
              >
                Access Denied
              </div>
              <div style={{ fontSize: '13px', color: '#742a2a', lineHeight: '1.5' }}>
                {error || adminError}
              </div>
            </div>
          </div>
        )}

        {!showAdminLogin ? (
          <>
            {/* Sign In Button */}
            <button
              onClick={login}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                width: '100%',
                padding: '16px',
                background: 'white',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#2d3748',
                cursor: 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#f7fafc';
                e.currentTarget.style.borderColor = '#667eea';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(102, 126, 234, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
              }}
            >
              <FaGoogle style={{ fontSize: '20px', color: '#EA4335' }} />
              Sign in with Google
            </button>

            {/* Divider */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                margin: '24px 0',
              }}
            >
              <div style={{ flex: 1, height: '1px', background: '#e2e8f0' }} />
              <span style={{ color: '#718096', fontSize: '13px', fontWeight: '500' }}>OR</span>
              <div style={{ flex: 1, height: '1px', background: '#e2e8f0' }} />
            </div>

            {/* Admin Login Link */}
            <button
              onClick={() => setShowAdminLogin(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '100%',
                padding: '12px',
                background: 'transparent',
                border: '1px dashed #cbd5e0',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                color: '#718096',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#667eea';
                e.currentTarget.style.color = '#667eea';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#cbd5e0';
                e.currentTarget.style.color = '#718096';
              }}
            >
              <FaKey style={{ fontSize: '14px' }} />
              Admin Override Login
            </button>
          </>
        ) : (
          <>
            {/* Admin Login Form */}
            <form onSubmit={handleAdminLogin} style={{ width: '100%' }}>
              <div style={{ marginBottom: '16px' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '13px',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '8px',
                  }}
                >
                  Username
                </label>
                <input
                  type="text"
                  value={adminUsername}
                  onChange={(e) => setAdminUsername(e.target.value)}
                  placeholder="Enter admin username"
                  required
                  style={{
                    width: '100%',
                    padding: '12px 14px',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '15px',
                    outline: 'none',
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{
                    display: 'block',
                    fontSize: '13px',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '8px',
                  }}
                >
                  Password
                </label>
                <input
                  type="password"
                  value={adminPassword}
                  onChange={(e) => setAdminPassword(e.target.value)}
                  placeholder="Enter admin password"
                  required
                  style={{
                    width: '100%',
                    padding: '12px 14px',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '15px',
                    outline: 'none',
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  width: '100%',
                  padding: '14px',
                  background: isSubmitting
                    ? '#cbd5e0'
                    : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  color: 'white',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 6px rgba(102, 126, 234, 0.3)',
                }}
              >
                <FaKey />
                {isSubmitting ? 'Logging in...' : 'Login as Admin'}
              </button>

              <button
                type="button"
                onClick={() => {
                  setShowAdminLogin(false);
                  setAdminError('');
                  setAdminUsername('');
                  setAdminPassword('');
                }}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'transparent',
                  border: 'none',
                  color: '#718096',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  marginTop: '12px',
                }}
              >
                ← Back to Google Sign In
              </button>
            </form>
          </>
        )}

        {/* Info Text */}
        <div
          style={{
            marginTop: '32px',
            padding: '16px',
            background: '#f7fafc',
            borderRadius: '8px',
            fontSize: '13px',
            color: '#718096',
            lineHeight: '1.6',
          }}
        >
          <strong style={{ color: '#4a5568', display: 'block', marginBottom: '8px' }}>
            Access restricted to Staff Council members
          </strong>
          Only NYU Abu Dhabi Staff Council members with registered email addresses can access
          this platform. If you believe you should have access, please contact the council
          administration.
        </div>
      </div>
    </div>
  );
}

